import React from "react";
import { Link } from "react-router-dom";
import { useT, useLang } from "../../context/LanguageContext";
import { t } from "../../data/translations";

const Footer = () => {
    const tr = useT();
    const { lang } = useLang();

    const quickLinks = [
        { to: "/", label: tr(t.nav.home) },
        { to: "/about", label: tr(t.nav.about) },
        { to: "/calculator", label: tr(t.nav.calculator) },
        { to: "/membership", label: tr(t.nav.membership) }
    ];

    const services = [
        { to: "/deposits", label: tr(t.deposits.tabs.fd) },
        { to: "/deposits", label: tr(t.deposits.tabs.rd) },
        { to: "/deposits", label: tr(t.deposits.tabs.mip) },
        { to: "/loans", label: tr(t.loans.title) }
    ];

    return (
        <footer className="bg-slate-900 text-slate-300 mt-24">
            <div className="brand-divider" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
                {/* Org block */}
                <div>
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-11 h-11 rounded-full bg-gradient-to-br from-red-700 to-amber-600 flex items-center justify-center shadow ring-2 ring-amber-300/30">
                            <span className="text-white font-extrabold text-lg">सु</span>
                        </div>
                        <div>
                            <div className="text-white font-bold text-base">{lang === "mr" ? "सुखकर्ता पतपेढी" : "Sukhakarta Patsanstha"}</div>
                            <div className="text-xs text-slate-400 uppercase tracking-widest">Since 1996</div>
                        </div>
                    </div>
                    <p className="text-sm leading-relaxed text-slate-400">
                        {tr(t.org.nameFull)}.<br />
                        {tr(t.org.regNo)}.
                    </p>
                </div>

                {/* Quick links */}
                <div>
                    <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">{tr(t.footer.quickLinks)}</h4>
                    <ul className="space-y-2 text-sm">
                        {quickLinks.map((l, i) => (
                            <li key={i}>
                                <Link to={l.to} className="hover:text-amber-400 transition-colors">
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Services */}
                <div>
                    <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">{tr(t.footer.services)}</h4>
                    <ul className="space-y-2 text-sm">
                        {services.map((l, i) => (
                            <li key={i}>
                                <Link to={l.to} className="hover:text-amber-400 transition-colors">
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Reach */}
                <div>
                    <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">{tr(t.footer.reach)}</h4>
                    <ul className="space-y-3 text-sm text-slate-400">
                        <li className="flex gap-2">
                            <i className="fa-solid fa-location-dot text-amber-500 mt-1" />
                            <span>{tr(t.contact.address)}</span>
                        </li>
                        <li className="flex gap-2">
                            <i className="fa-solid fa-phone text-amber-500 mt-1" />
                            <a href="tel:+919987070049" className="hover:text-amber-400">9987070049</a> /{" "}
                            <a href="tel:+918591385792" className="hover:text-amber-400">8591385792</a>
                        </li>
                        <li className="flex gap-2">
                            <i className="fa-solid fa-clock text-amber-500 mt-1" />
                            <div>
                                <div>{tr(t.hours.weekdays)}</div>
                                <div className="text-xs">{tr(t.hours.lunch)}</div>
                                <div className="text-xs">{tr(t.hours.sunday)}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-slate-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} {tr(t.org.nameFull)}. {tr(t.footer.rights)}
                    </p>
                    <p className="text-xs text-slate-500">
                        {tr(t.org.regNo)}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
